import React from 'react'
const HeadeTitle = ({title}) => (
    <div className="page-title">
        <div className="d-table">
            <div className="d-table-cell">
                <div className="container">
                    <h3>{title}</h3>
                </div>
            </div>
        </div>
    </div>
)

export default HeadeTitle